export default { sha: '6b925f11c6cc25079bd09d3485350484a0c6d260', buildNumber: 'undefined' }
